@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="span9">
  <h1 data-automation-name="resourceIndex"> Resources</h1>
</div>
<p class="lead">
  Resources are a potential component of an OADR dispatch event that indicates the program unit(s) of the event.
</p>
@if(isAdmin) {
  <div class="span3" style="text-align:right;">
    <a id="createResource" class="btn btn-large btn-primary" (click)="nextPage($event, '/createResource', router)" style="margin-top:9px;"> Create Resource</a>
  </div>
}

@if(isLoading) {
  <app-loader
    message="Loading Resources...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>ID</th>
      <th>Resource id</th>
      <th>Registration UUID</th>
      <th># Events</th>
      <th># Vens</th>
      <th>Label</th>
      <th>Last Modified By</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Resource ID" class="input-sm form-control" type="search" [(ngModel)]="resourceIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Registration UUID" class="input-sm form-control" type="search" [(ngModel)]="registrationIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="# Events" class="input-sm form-control" type="search" [(ngModel)]="eventsCountSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="# VENs" class="input-sm form-control" type="search" [(ngModel)]="vensCountSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Label" class="input-sm form-control" type="search" [(ngModel)]="labelSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Modified By" class="input-sm form-control" type="search" [(ngModel)]="updatedBySearch" (input)="triggerSearch()"/></th>
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for (resource of displayedResources | paginate: paginationModel; track resource) {
        <tr class="table-active">
          <td>{{ resource.id }}</td>
          <td>{{ resource.resource_id }}</td>
          <td>{{ resource.program_unit }}</td>
          <td>{{ resource.events.length || 0 }}</td>
          <td>{{ resource.vens.length || 0 }}</td>
          <td>{{ resource.label }}</td>
          <td id="updated_by">{{ resource.updated_by }}</td>
          @if (isAdmin) {
            <td>
              <div class="btn-group">
                <a class="btn btn-default" (click)="nextPage(resource.id, '/editResource', router)" name="editResource">Edit</a>
                <button class="btn btn-danger" type="button" (click)="delete(resource)">Delete</button>
              </div>
            </td>
          }
        </tr>
      }
      @if(displayedResources.length <= 0) {
        <tr>
          <td [attr.colspan]="isAdmin ? 8 : 7" style="text-align: center;">No resources found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 8 : 7">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
